import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import InfoMessage from "src/app/components/InfoMessage";

function OutOfHoursInfoMessage({
  openingTimes,
  countryCode,
  formatTranslation,
}) {
  const infoMessage =
    countryCode === "US"
      ? "cchp_live_chat_out_of_hours_message_us_only"
      : "cchp_live_chat_out_of_hours_message";

  return (
    <InfoMessage>
      <p>
        {formatTranslation(infoMessage, {
          nextOpeningTime:
            countryCode === "US" ? "05:00-23:59 (CDT)" : openingTimes,
        })}
      </p>
    </InfoMessage>
  );
}

OutOfHoursInfoMessage.propTypes = {
  countryCode: PropTypes.string,
  openingTimes: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(OutOfHoursInfoMessage);
